import { apiClient } from './config'

export const uploadService = {
  async uploadFile(file) {
    const formData = new FormData()
    formData.append('file', file)
    
    return apiClient.post('/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },

  async uploadKYCDocument(file) {
    const formData = new FormData()
    formData.append('file', file)
    
    return apiClient.post('/upload/kyc', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },

  async uploadImage(file) {
    return this.uploadFile(file)
  },

  async uploadDocument(file) {
    return this.uploadFile(file)
  },
}
